import { SettlementStatus } from "enums";

export const settlementHistoryFilterState = () => ({
  startDate: null,
  endDate: null,
  dealerSettlementStatuses: [SettlementStatus.ForProcessing, SettlementStatus.Processed],
  perPage: 10,
  page: 1,
});
